import Axios from "../utils/axiosInterceptor";
import { API_URL, DISALLOWANCE_APIS, EODBOD_APIS, RECONCILIATION_APIS } from "../utils/constants";

export const getFillMappers = async () => {
  try {
    const res = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/allFiles`,
    );
    return res.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const saveFileMapper = async (formData: any) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/fileMapper`,
      formData,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const saveMapping = async (data: any) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/saveFileMapper`,
      data,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getProcessedFiles = async (healthcareId: number, filters: any) => {
  try {
    const res = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/healthcareId/${healthcareId}/getProcessedFiles?page=${filters.pageNumber}&size=${filters.pageSize}`,
    );
    return res.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const processedResults = async (fileReconId: any, filters: any) => {
  try {
    let url = `${RECONCILIATION_APIS.RECONCILIATION}/fileRecon/${fileReconId}/processedResults?status=${filters?.tab}&page=${filters.pageNumber}&size=${filters.pageSize}`;
    if (filters.searchTerm) {
      url = `${url}&searchKey=${filters.searchTerm}`;
    }
    if (filters.visitType) {
      url = `${url}&visitType=${filters.visitType}`;
    }
    if (filters.sortBy) {
      url = `${url}&sortBy=${filters.sortBy}&sortDir=${filters.sortDir}`;
    }
    if (filters.schemes) {
      url = `${url}&schemes=${filters.schemes
        ?.map(encodeURIComponent)
        .join(",")}`;
    }
    const res = await Axios.get(url);
    return res.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const downloadExcelReconciliation = async (data: any) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/exportToExcel`,
      data,
      {
        responseType: "arraybuffer",
      },
    );

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : "Reconciliation_File.xlsx";

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Create a link element to initiate the download
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error(
      "Error in downloading excel of all reconciliation data:",
      error,
    );
    throw new Error("Error in downloading excel of all reconciliation data");
  }
};

export const getFileMapperByHospital = async (data: any) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/fileMapperByHospital`,
      data,
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const updateFileMapperByHospital = async (data: any) => {
  try {
    const response = await Axios.patch(
      `${RECONCILIATION_APIS.RECONCILIATION}/fileMapperByHospital`,
      data,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getAllSchemesFromExcel = async (fileReconId: any) => {
  try {
    const res = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/getAllSchemesFromExcel/${fileReconId}`,
    );
    return res.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getAllVisitTypesFromExcel = async (fileReconId: any) => {
  try {
    const res = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/getAllVisitTypesFromExcel/${fileReconId}`,
    );
    return res.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const updateReconciliationData = async (data: any) => {
  try {
    const res = await Axios.patch(
      `${RECONCILIATION_APIS.RECONCILIATION}/reconResults/update`,
      data,
    );
    return res.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getReconciliationSummary = async (
  fileReconId: any,
  filter: any,
) => {
  try {
    let url = `${RECONCILIATION_APIS.RECONCILIATION}/summary/${fileReconId}?`;

    if (filter.visitType) {
      url = `${url}&visitType=${filter.visitType}`;
    }
    if (filter.schemes && filter.schemes.length > 0) {
      url = `${url}&schemes=${filter.schemes
        .map(encodeURIComponent)
        .join(",")}`;
    }

    const res = await Axios.get(url);
    return res.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getOPData = async (data: any) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/op/metrics`,
      data,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getOPDataDownload = async (data: any) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/op/metrics/export`,
      data,
      { responseType: "arraybuffer" },
    );

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : "Bill_Count_Of_Claims_Submitted_(G7).xlsx";

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getIPData = async (data: any) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/ip/metrics`,
      data,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getG7RegnPending = async (
  hospitalId: any,
  schemeId: any,
  orderBy?: any,
  direction?: any,
  pageNumber?: any,
  pageSize?: any,
  visitType?: any,
) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/v2/g7-reg-pending`,
      {
        hospitalId: hospitalId,
        schemeId,
        orderBy: direction ? orderBy : null,
        direction: direction ? direction : null,
        pageNumber: pageNumber ?? 0,
        pageSize: pageSize ?? 20,
        visitType: visitType && visitType !== "ALL" ? visitType : null,
      },
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getG7RegnPendingExport = async (payload: any, modalStageName: string) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/v2/g7-reg-pending/export`,
      payload,
      { responseType: "arraybuffer" },
    );

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : `${modalStageName}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error in downloading excel of all dashboard data:", error);
    throw new Error("Error in downloading excel of all dashboard data");
  }
};

export const getBillsMissing = async (
  hospitalId: any,
  schemeId: any,
  orderBy?: any,
  direction?: any,
  pageNumber?: any,
  pageSize?: any,
  visitType?: any,
) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/v2/bills-missing`,
      {
        hospitalId: hospitalId,
        schemeId,
        orderBy: direction ? orderBy : null,
        direction: direction ? direction : null,
        pageNumber: pageNumber ?? 0,
        pageSize: pageSize ?? 20,
        visitType: visitType && visitType !== "ALL" ? visitType : null,
      },
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getBillsMissingExport = async (payload: any, modalStageName: string) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/v2/bills-missing/export`,
      payload,
      { responseType: "arraybuffer" },
    );

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : `${modalStageName}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error in downloading excel of all dashboard data:", error);
    throw new Error("Error in downloading excel of all dashboard data");
  }
};

export const getPreAuthPending = async (
  hospitalId: any,
  schemeId: any,
  orderBy?: any,
  direction?: any,
  pageNumber?: any,
  pageSize?: any,
  visitType?: any,
) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/v2/preauth-pending-aged`,
      {
        hospitalId: hospitalId,
        schemeId,
        orderBy: direction ? orderBy : null,
        direction: direction ? direction : null,
        pageNumber: pageNumber ?? 0,
        pageSize: pageSize ?? 20,
        visitType: visitType && visitType !== "ALL" ? visitType : null,
      },
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getPreAuthPendingExport = async (payload: any, modalStageName: string) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/v2/preauth-pending-aged/export`,
      payload,
      { responseType: "arraybuffer" },
    );

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : `${modalStageName}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error in downloading excel of all dashboard data:", error);
    throw new Error("Error in downloading excel of all dashboard data");
  }
};

export const getEchsReviewRequest = async (
  hospitalId: any,
  schemeId: any,
  orderBy?: any,
  direction?: any,
  pageNumber?: any,
  pageSize?: any,
  visitType?: any,
) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/v2/echs-review-request`,
      {
        hospitalId: hospitalId,
        schemeId,
        orderBy: direction ? orderBy : null,
        direction: direction ? direction : null,
        pageNumber: pageNumber ?? 0,
        pageSize: pageSize ?? 20,
        visitType: visitType && visitType !== "ALL" ? visitType : null,
      },
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getEchsReviewRequestExport = async (payload: any, modalStageName: string) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/v2/echs-review-request/export`,
      payload,
      { responseType: "arraybuffer" },
    );

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : `${modalStageName}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error in downloading excel of all dashboard data:", error);
    throw new Error("Error in downloading excel of all dashboard data");
  }
};

export const getCghsNewArbitrationPending = async (
  hospitalId: any,
  schemeId: any,
  orderBy?: any,
  direction?: any,
  pageNumber?: any,
  pageSize?: any,
  visitType?: any,
) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/v2/cghs-new-arbitration-pending`,
      {
        hospitalId,
        schemeId,
        orderBy: direction ? orderBy : null,
        direction: direction ? direction : null,
        pageNumber: pageNumber ?? 0,
        pageSize: pageSize ?? 20,
        visitType: visitType && visitType !== "ALL" ? visitType : null,
      },
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getCghsNewArbitrationPendingExport = async (
  payload: any,
  modalStageName: string,
) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/v2/cghs-new-arbitration-pending/export`,
      payload,
      { responseType: "arraybuffer" },
    );

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : `${modalStageName}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error in downloading CGHS NEW arbitration excel:", error);
    throw new Error("Error in downloading CGHS NEW arbitration excel");
  }
};

export const getPayerQueryPending = async (
  hospitalId: any,
  schemeId: any,
  orderBy: any,
  direction: any,
  searchTerm: any,
  pageNumber?: any,
  pageSize?: any,
  visitType?: any,
  stateName?: any,
) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/v2/payer-query-pending`,
      {
        hospitalId: hospitalId,
        schemeId: schemeId,
        orderBy: direction ? orderBy : null,
        direction: direction ? direction : null,
        search: searchTerm ? searchTerm : null,
        pageNumber: pageNumber ?? 0,
        pageSize: pageSize ?? 20,
        visitType: visitType && visitType !== "ALL" ? visitType : null,
        stateName: stateName && stateName !== "ALL" ? stateName : null,
      },
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getPayerQueryPendingExport = async (payload: any, modalStageName: string) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/v2/payer-query-pending/export`,
      payload,
      { responseType: "arraybuffer" },
    );

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : `${modalStageName}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error in downloading excel of all dashboard data:", error);
    throw new Error("Error in downloading excel of all dashboard data");
  }
};

export const getPayerQueryPendingExportExcel = async (
  hospitalId: any,
  schemeId: any,
) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/v2/payer-query-pending/export`,
      {
        hospitalId: hospitalId,
        schemeId: schemeId,
      },
      { responseType: "arraybuffer" },
    );

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : `Payer_Query_Pending.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getRegistrationTodayCountModalData = async (
  hospitalId: any,
  date: any,
  schemeId: any,
) => {
  try {
    const response = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/op/registration-today?hospitalId=${hospitalId}&date=${date}&schemeId=${schemeId}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getHSPCaseCountTodayCountModalData = async (
  hospitalId: any,
  date: any,
  schemeId: any,
) => {
  try {
    const response = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/op/hsp-case-count-today?hospitalId=${hospitalId}&date=${date}&schemeId=${schemeId}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getRegistrationPendingOnG7MTDCountModalData = async (
  hospitalId: any,
  date: any,
  schemeId: any,
) => {
  try {
    const response = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/op/registration-pending-g7?hospitalId=${hospitalId}&date=${date}&schemeId=${schemeId}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getPreAuthPendingAsPerPayerPortalCountModalData = async (
  hospitalId: any,
  date: any,
  schemeId: any,
) => {
  try {
    const response = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/op/preauth-pending-portal?hospitalId=${hospitalId}&date=${date}&schemeId=${schemeId}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getPreAuthPendingGreaterThan36HourCountModalData = async (
  hospitalId: any,
  date: any,
  schemeId: any,
) => {
  try {
    const response = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/op/preauth-pending-portal-aged?hospitalId=${hospitalId}&date=${date}&schemeId=${schemeId}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getClaimSubmissionAsPerG7CountModalData = async (
  hospitalId: any,
  date: any,
  schemeId: any,
) => {
  try {
    const response = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/op/claim-submissions-g7?hospitalId=${hospitalId}&date=${date}&schemeId=${schemeId}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getClaimPendingPayerPortalCountModalData = async (
  hospitalId: any,
  date: any,
  schemeId: any,
) => {
  try {
    const response = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/op/claim-pending-portal?hospitalId=${hospitalId}&date=${date}&schemeId=${schemeId}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getBillCountOfClaimSubmittedCountModalData = async (
  hospitalId: any,
  date: any,
  schemeId: any,
  search?: any,
) => {
  try {
    let url = `${RECONCILIATION_APIS.RECONCILIATION}/op/bill-count-claim-submitted?hospitalId=${hospitalId}&date=${date}&schemeId=${schemeId}`
    
    if (search) {
      url = `${url}&search=${search}`
    }

    const response = await Axios.get(url);
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getBillCountOfClaimSubmittedG7CountModalData = async (
  hospitalId: any,
  date: any,
  schemeId: any,
  search?: any,
) => {
  try {
    let url = `${RECONCILIATION_APIS.RECONCILIATION}/op/bill-count-claim-submitted-g7?hospitalId=${hospitalId}&date=${date}&schemeId=${schemeId}`;

    if (search) {
      url = `${url}&search=${search}`
    }
    
    const response = await Axios.get(url);
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getClaimAmountAsPerCreditCountModalData = async (
  hospitalId: any,
  date: any,
  schemeId: any,
) => {
  try {
    const response = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/op/claim-amount-credit-reg?hospitalId=${hospitalId}&date=${date}&schemeId=${schemeId}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getClaimAmountG7SubmissionCountModalData = async (
  hospitalId: any,
  date: any,
  schemeId: any,
) => {
  try {
    const response = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/op/claim-amount-g7?hospitalId=${hospitalId}&date=${date}&schemeId=${schemeId}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const fetchProcessHistory = async (payload: any) => {
  try {
    const response = await Axios.post(
      `${EODBOD_APIS.EODBOD}/fetchActivity/getAll`,
      payload,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const fetchInitialEODBODConfig = async (
  hospitalId: any,
  eodBodProcessType: any,
  date: any,
) => {
  try {
    const response = await Axios.post(
      `${EODBOD_APIS.EODBOD}/orchestrator/page-control?hospitalId=${hospitalId}&eodBodProcessType=${eodBodProcessType}&date=${date}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const fetchPortalDataForCGHSNewForEODBOD = async (
  hospitalId: number,
  schemeId: number,
  type: any,
  orchestratorId?: any,
) => {
  try {
    const response = await Axios.post(
      `${API_URL}/api/cghs_new/fetchPortalData`,
      { hospitalId, schemeId, type, orchestratorId },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchPortalDataForEchsForEODBOD = async (
  hospitalId: number,
  schemeId: number,
  type: any,
  orchestratorId?: any,
) => {
  try {
    const response = await Axios.post(`${API_URL}/api/echs/fetchPortalData`, {
      hospitalId,
      schemeId,
      type,
      orchestratorId,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchPortalDataForAyushmanBharatForEODBOD = async (
  hospitalId: number,
  schemeId: number,
  type: any,
  orchestratorId?: any,
) => {
  try {
    const response = await Axios.post(
      `${API_URL}/api/ayushmanBharat/fetchPortalData`,
      { hospitalId, schemeId, type, orchestratorId }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchLoginHistory = async (payload: any) => {
  try {
    const response = await Axios.post(
      `${EODBOD_APIS.EODBOD}/login/getAll`,
      payload,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const fetchProcessedFiles = async (payload: any) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/getProcessedFiles`,
      payload,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const fetchReportAndStatusData = async (payload: any) => {
  try {
    const response = await Axios.post(
      `${EODBOD_APIS.EODBOD}/fetchActivity/schemeWise`,
      payload,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getPortalSummaryByActivityId = async (
  activityId: number,
  hospitalId: number,
  schemeId: number,
  page: number,
  size: number,
) => {
  try {
    const response = await Axios.get(
      `${EODBOD_APIS.EODBOD}/portal/summary/${activityId}?hospitalId=${hospitalId}&schemeId=${schemeId}&page=${page}&size=${size}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getPortalDetailsByTypeAndId = async (
  type: string,
  id: number,
  hospitalId: number,
  schemeId: number,
  page: number,
  size: number,
  searchQuery?: string,
) => {
  try {
    const response = await Axios.get(
      `${EODBOD_APIS.EODBOD}/portal/details?type=${type}&id=${id}&hospitalId=${hospitalId}&schemeId=${schemeId}&page=${page}&size=${size}&searchQuery=${searchQuery ?? ""}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getPortalDetailsByTypeAndIdExport = async (
  type: string,
  id: number,
  hospitalId: number,
  schemeId: number,
  page: number,
  size: number,
  searchQuery?: string,
  fileName?: string,
) => {
  try {
    const response = await Axios.get(
      `${EODBOD_APIS.EODBOD}/portal/details/export?type=${type}&id=${id}&hospitalId=${hospitalId}&schemeId=${schemeId}&page=${page}&size=${size}&searchQuery=${searchQuery ?? ""}`,
      { responseType: "arraybuffer" },
    );

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : `${fileName || "Portal_Details"}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getIpClaimIdsGeneratedToday = async (
  hospitalId: any,
  date: any,
  schemeId: any,
) => {
  try {
    const response = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/ip/ip-claim-ids-generated-today?hospitalId=${hospitalId}&date=${date}&schemeId=${schemeId}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getAdmittedNotRegisteredOnG7 = async (
  hospitalId: any,
  date: any,
  schemeId: any,
) => {
  try {
    const response = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/ip/admitted-not-registered-g7?hospitalId=${hospitalId}&date=${date}&schemeId=${schemeId}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getPreauthMtdIp = async (
  hospitalId: any,
  schemeId: any,
  endDate: any,
  startDate: any,
) => {
  try {
    const response = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/ip/preauth-mtd-ip?hospitalId=${hospitalId}&schemeId=${schemeId}&endDate=${endDate}&startDate=${startDate}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getPreauthPending0To24Hours = async (
  hospitalId: any,
  date: any,
  schemeId: any,
) => {
  try {
    const response = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/ip/preauth-pending-0-24-hours?hospitalId=${hospitalId}&date=${date}&schemeId=${schemeId}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getPreauthPendingGreaterThan24Hours = async (
  hospitalId: any,
  date: any,
  schemeId: any,
) => {
  try {
    const response = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/ip/preauth-pending-greater-than-24-hours?hospitalId=${hospitalId}&date=${date}&schemeId=${schemeId}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getClaimSubmissionsMtdG7 = async (
  hospitalId: any,
  schemeId: any,
  endDate: any,
  startDate: any,
) => {
  try {
    const response = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/ip/claim-submissions-mtd-g7?hospitalId=${hospitalId}&schemeId=${schemeId}&endDate=${endDate}&startDate=${startDate}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getClaimSubmissionsPendingMtd = async (
  hospitalId: any,
  schemeId: any,
  endDate: any,
  startDate: any,
) => {
  try {
    const response = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/ip/claim-submissions-pending-mtd?hospitalId=${hospitalId}&schemeId=${schemeId}&endDate=${endDate}&startDate=${startDate}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getClaimSubmissionPendingGreaterThan72Hrs = async (
  hospitalId: any,
  date: any,
  schemeId: any,
) => {
  try {
    const response = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/ip/claim-submission-pending-greater-than-72-hrs?hospitalId=${hospitalId}&date=${date}&schemeId=${schemeId}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getClaimAmountMtdSubmissions = async (
  hospitalId: any,
  schemeId: any,
  endDate: any,
  startDate: any,
) => {
  try {
    const response = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/ip/claim-amount-mtd-submissions?hospitalId=${hospitalId}&schemeId=${schemeId}&endDate=${endDate}&startDate=${startDate}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getUnlisted = async (
  hospitalId: any,
  date: any,
  schemeId: any,
) => {
  try {
    const response = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/ip/unlisted?hospitalId=${hospitalId}&date=${date}&schemeId=${schemeId}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getExtensionOfStay = async (
  hospitalId: any,
  date: any,
  schemeId: any,
) => {
  try {
    const response = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/ip/extension-of-stay?hospitalId=${hospitalId}&date=${date}&schemeId=${schemeId}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getAdmissionToday = async (
  hospitalId: any,
  date: any,
  schemeId: any,
) => {
  try {
    const response = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/ip/admissions-today?hospitalId=${hospitalId}&date=${date}&schemeId=${schemeId}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getDischargeTodayData = async (
  hospitalId: any,
  date: any,
  schemeId: any,
) => {
  try {
    const response = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/ip/discharge-today-data?hospitalId=${hospitalId}&date=${date}&schemeId=${schemeId}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getDayCareDischargeData = async (
  hospitalId: any,
  date: any,
  schemeId: any,
) => {
  try {
    const response = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/ip/day-care-discharge-data?hospitalId=${hospitalId}&date=${date}&schemeId=${schemeId}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getAmountAsPerCreditRegister = async (
  hospitalId: any,
  schemeId: any,
  endDate: any,
  startDate: any,
) => {
  try {
    const response = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/ip/claim-amount-credit-reg?hospitalId=${hospitalId}&schemeId=${schemeId}&endDate=${endDate}&startDate=${startDate}`,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const saveReconRegisterType = async (formData: any) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/fileTypeRouting/save`,
      formData,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getUploadInputList = async (
  hospitalId: number,
  visitType: string,
) => {
  try {
    const res = await Axios.get(
      `${RECONCILIATION_APIS.RECONCILIATION}/fileTypeRouting/uploadInputList/${hospitalId}?visitType=${visitType}`,
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const getReconDataCounts = async (
  hospitalId: any,
) => {
  try {
    const res = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/v2/recon-data-counts`, {
        hospitalId: hospitalId,
      }
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const midOfficeManagementAlert = async (payload: any) => {
  try {
    const res = await Axios.post(`${EODBOD_APIS.EODBOD}/management-alert-dashboard`, payload);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const ageStageWiseDashboard = async (payload: any) => {
  try {
    const res = await Axios.post(`${EODBOD_APIS.EODBOD}/age-stage-wise-dashboard`, payload);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const midOfficeManagementAlertDetails = async (payload: any) => {
  try {
    const res = await Axios.post(`${EODBOD_APIS.EODBOD}/management-alert-dashboard/details`, payload);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const ageStageWiseDashboardDetails = async (payload: any) => {
  try {
    const res = await Axios.post(`${EODBOD_APIS.EODBOD}/age-stage-wise-dashboard/details`,payload);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const ageStageWiseDashboardDetailsExport = async (payload: any, modalStageName: string) => {
  try {
    const response = await Axios.post(
      `${EODBOD_APIS.EODBOD}/age-stage-wise-dashboard/details/export`,
      payload,
      { responseType: "arraybuffer" },
    );

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : `${modalStageName}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error in downloading excel of all dashboard data:", error);
    throw new Error("Error in downloading excel of all dashboard data");
  }
};

export const midOfficeManagementAlertDetailsExport = async (payload: any, modalStageName: string) => {
  try {
    const response = await Axios.post(
      `${EODBOD_APIS.EODBOD}/management-alert-dashboard/details/export`,
      payload,
      { responseType: "arraybuffer" },
    );

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : `${modalStageName}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error in downloading excel of all dashboard data:", error);
    throw new Error("Error in downloading excel of all dashboard data");
  }
};

export const opReconCountModalExport = async (
  payload: any,
  title: string,
  endpoint?: string,
) => {
  try {
    const url =
      `${RECONCILIATION_APIS.RECONCILIATION}${endpoint}` ||
      `${RECONCILIATION_APIS.RECONCILIATION}/op/orchestrator/mid-office-dashboard/details/export`;
    const response = endpoint
      ? await Axios.get(url, {
          params: payload,
          responseType: "arraybuffer",
        })
      : await Axios.post(url, payload, { responseType: "arraybuffer" });

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : `${title}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error in downloading excel of all dashboard data:", error);
    throw new Error("Error in downloading excel of all dashboard data");
  }
};

export const ipReconCountModalExport = async (
  payload: any,
  title: string,
  endpoint?: string,
) => {
  try {
    const url =
      `${RECONCILIATION_APIS.RECONCILIATION}${endpoint}` ||
      `${RECONCILIATION_APIS.RECONCILIATION}/ip/orchestrator/mid-office-dashboard/details/export`;
    const response = endpoint
      ? await Axios.get(url, {
          params: payload,
          responseType: "arraybuffer",
        })
      : await Axios.post(url, payload, { responseType: "arraybuffer" });

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : `${title}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error in downloading excel of all dashboard data:", error);
    throw new Error("Error in downloading excel of all dashboard data");
  }
};

export const opReconMissingBillReport = async (payload: any) => {
  try {
    const res = await Axios.post(`${RECONCILIATION_APIS.RECONCILIATION}/v2/missing-bill-report`,payload);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const opReconMissingBillReportExport = async (payload: any, title: string) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/v2/missing-bill-report/export`,
      payload,
      { responseType: "arraybuffer" },
    );

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : `${title}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error in downloading excel of all dashboard data:", error);
    throw new Error("Error in downloading excel of all dashboard data");
  }
};

export const getIpClaimIdsGenerated = async (payload: any) => {
  try {
    const res = await Axios.post(`${RECONCILIATION_APIS.RECONCILIATION}/ip/metrics/claim-ids-by-month`,payload);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const opReconMissingBillReportCRNoFound = async (payload: any) => {
  try {
    const res = await Axios.post(`${RECONCILIATION_APIS.RECONCILIATION}/v2/g7-crNo-found`,payload);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const opReconMissingBillReportCRNoFoundCreditRegisterBills = async (payload: any) => {
  try {
    const res = await Axios.post(`${RECONCILIATION_APIS.RECONCILIATION}/v2/g7-crNo-found/credit-register-bills`,payload);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const opReconMissingBillReportCRNoFoundBillsFoundInG7 = async (payload: any) => {
  try {
    const res = await Axios.post(`${RECONCILIATION_APIS.RECONCILIATION}/v2/g7-crNo-found/bills-found-in-g7`,payload);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const opReconMissingBillReportCRNoFoundBillsNotFoundInG7 = async (payload: any) => {
  try {
    const res = await Axios.post(`${RECONCILIATION_APIS.RECONCILIATION}/v2/g7-crNo-found/bills-not-found-in-g7`,payload);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const opReconMissingBillReportCRNoFoundCreditRegisterBillsFoundG7BillsNotFoundG7Export = async (
  payload: any,
  title: string,
  path: "credit-register-bills" | "bills-found-in-g7" | "bills-not-found-in-g7",
) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/v2/g7-crNo-found/${path}/export`,
      payload,
      { responseType: "arraybuffer" },
    );

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : `${title}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error in downloading g7 cr no found excel:", error);
    throw new Error("Error in downloading g7 cr no found excel");
  }
};

export const midOfficeManagementAlertMiscellaneous = async (payload: any) => {
  try {
    const res = await Axios.post(`${EODBOD_APIS.EODBOD}/management-alert-dashboard/miscellaneous`, payload);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const midOfficeManagementAlerMiscellaneousDetails = async (payload: any) => {
  try {
    const res = await Axios.post(`${EODBOD_APIS.EODBOD}/management-alert-dashboard/miscellaneous/details`, payload);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const midOfficeManagementAlertMiscellaneousDetailsExport = async (payload: any, modalStageName: string) => {
  try {
    const response = await Axios.post(
      `${EODBOD_APIS.EODBOD}/management-alert-dashboard/miscellaneous/details/export`,
      payload,
      { responseType: "arraybuffer" },
    );

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : `${modalStageName}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error in downloading excel of all dashboard data:", error);
    throw new Error("Error in downloading excel of all dashboard data");
  }
};

export const getRegistersData = async (payload: any) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/recon-excel-data/list`,
      payload,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const updateg7CRNORegistersData = async (payload: any) => {
  try {
    const response = await Axios.patch(
      `${RECONCILIATION_APIS.RECONCILIATION}/recon-excel-data/g7-cr-no`,
      payload,
    );
    return response.data;
  } catch (err: any) {
    throw err;
  }
};

export const getRegistersDataExport = async (
  payload: any,
  fileName?: string,
) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/recon-excel-data/list/export`,
      payload,
      { responseType: "arraybuffer" },
    );

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : `${fileName || "Registers_Data"}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getRegistersDataPreauthPending = async (payload: any) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/recon-excel-data/list/preauth-pending`,
      payload,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getRegistersDataPreauthPendingExport = async (
  payload: any,
  fileName?: string,
) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/recon-excel-data/list/preauth-pending/export`,
      payload,
      { responseType: "arraybuffer" },
    );

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : `${fileName || "Registers_Data"}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getRegistersDataDischargePending = async (payload: any) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/recon-excel-data/list/discharge-pending`,
      payload,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getRegistersDataDischargePendingExport = async (
  payload: any,
  fileName?: string,
) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/recon-excel-data/list/discharge-pending/export`,
      payload,
      { responseType: "arraybuffer" },
    );

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : `${fileName || "Registers_Data"}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getRegistersDataClaimPending = async (payload: any) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/recon-excel-data/list/claim-pending`,
      payload,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getRegistersDataClaimPendingExport = async (
  payload: any,
  fileName?: string,
) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/recon-excel-data/list/claim-pending/export`,
      payload,
      { responseType: "arraybuffer" },
    );

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : `${fileName || "Registers_Data"}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getRegistersDataTilesData = async (payload: any) => {
  try {
    const response = await Axios.post(
      `${RECONCILIATION_APIS.RECONCILIATION}/recon-excel-data/list/pending`,
      payload,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getLastLoginHistory = async (payload: any) => {
  try {
    const response = await Axios.post(
      `${EODBOD_APIS.EODBOD}/login/getLastLogins`,
      payload,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getCghsDisallowanceData = async (payload: any) => {
  try {
    const response = await Axios.post(
      `${DISALLOWANCE_APIS.CGHS_DISALLOWANCE}`,
      payload,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getCghsDisallowanceDataExport = async (
  payload: any,
  fileName?: string,
) => {
  try {
    const response = await Axios.post(
      `${DISALLOWANCE_APIS.CGHS_DISALLOWANCE_EXPORT}`,
      payload,
      { responseType: "arraybuffer" },
    );

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : `${fileName || "Cghs_Disallowance"}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getEchsDisallowanceData = async (payload: any) => {
  try {
    const response = await Axios.post(
      `${DISALLOWANCE_APIS.ECHS_DISALLOWANCE}`,
      payload,
    );
    return response.data;
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const getEchsDisallowanceDataExport = async (
  payload: any,
  fileName?: string,
) => {
  try {
    const response = await Axios.post(
      `${DISALLOWANCE_APIS.ECHS_DISALLOWANCE_EXPORT}`,
      payload,
      { responseType: "arraybuffer" },
    );

    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : `${fileName || "Echs_Disallowance"}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    throw new Error("Please, Try again later");
  }
};

export const retrySummaryDataFetchEODBOD = async (payload: any) => {
  try {
    const response = await Axios.post(
      `${API_URL}/api/echs/retryPortalFetchLeg`,
      payload,
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const triggerAuditTrailsSummaryDataFetchEODBOD = async (payload: any) => {
  try {
    const response = await Axios.post(
      `${API_URL}/api/echs/triggerMissingQueryAuditTrails`,
      payload,
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const triggerAuditRemarksSummaryDataFetchEODBOD = async (payload: any) => {
  try {
    const response = await Axios.post(
      `${API_URL}/api/echs/triggerMissingSettlementAuditRemarks`,
      payload,
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const getEchsG7SyncReadiness = async (
  hospitalId: number,
  schemeId: number,
  eodBodFetchActivityId?: number | null,
) => {
  const activityQs =
    eodBodFetchActivityId != null
      ? `&eodBodFetchActivityId=${eodBodFetchActivityId}`
      : "";
  const response = await Axios.get(
    `${API_URL}/api/echs/g7Sync/readiness?hospitalId=${hospitalId}&schemeId=${schemeId}${activityQs}`,
  );
  return response.data;
};

export const syncEchsG7PreauthPending = async (payload: any) => {
  const response = await Axios.post(
    `${API_URL}/api/echs/g7Sync/preauthPending`,
    payload,
  );
  return response.data;
};

export const syncEchsG7ClaimPending = async (payload: any) => {
  const response = await Axios.post(
    `${API_URL}/api/echs/g7Sync/claimPending`,
    payload,
  );
  return response.data;
};

export const syncEchsG7SettlementPending = async (payload: any) => {
  const response = await Axios.post(
    `${API_URL}/api/echs/g7Sync/settlementPending`,
    payload,
  );
  return response.data;
};

export const syncEchsG7AuditRemarks = async (payload: any) => {
  const response = await Axios.post(
    `${API_URL}/api/echs/g7Sync/auditRemarks`,
    payload,
  );
  return response.data;
};

export const syncEchsG7Query = async (payload: any) => {
  const response = await Axios.post(
    `${API_URL}/api/echs/g7Sync/query`,
    payload,
  );
  return response.data;
};